<template>
  <div class="page-list">
    <div class="page-title">
      <div class="page-back" @click="$router.go(-1)">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z"/>
        </svg>
      </div>
      Ценности
    </div>
    <div class="page-subtitle" style="text-align: justify">
      <span style="display: inline-block; width: 16px"></span>В сети клиник "Садко" есть качества, которые мы особенно ценим, - наши корпоративные ценности. Мы с Вами проявляем их в ежедневных задачах, часто даже не задумываясь об этом. Именно за такие проявления мы предлагаем благодарить коллег и вручать особые знаки отличия. <br> <br> <span style="display: inline-block; width: 16px"></span>Каждая благодарность будет конвертироваться в баллы для её получателя - виртуальную валюту. На накопленные баллы Вы сможете приобрести классные подарки в виртуальном магазине Садко, который скоро откроется.<br> <br> <b>За что вы можете поблагодарить коллегу и сказать "СПАСИБО":</b>
    </div>
    <div class="card" v-for="it in values" :key="it.id" style="width: 100%; border-left: 5px solid green; border-right: 5px solid green" :style="{'border-color': it.color}">
      <div class="card-title"> <span class="card-icon" v-html="it.icon"> </span>{{ it.name }}</div>
      <div class="card-subtitle"> {{ it.description }}
      </div>
      <ul>
        <li class="card-list" v-for="(it, index) in it.conditions" :key="index"> {{ it }} </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThanksPage',
  data: function () {
    return {
      selectedGroup: -1
    }
  },
  computed: {
    values() {
      return this.$store.getters.values
    }
  },
  methods: {
    openTask(taskId) {
      console.log(taskId)
      // this.$store.commit('selectTask', taskId)
      // this.$router.push('/task')
    },
    getImages() {
      return this.tasks.filter(it => it.icon.length > 0).map(it => it.icon)
    },

    /**
     * Выбор группы
     * @param groupId
     */
    selectGroup(groupId) {
      if (this.selectedGroup === groupId) this.selectedGroup = -1
      else this.selectedGroup = groupId
    },

    /**
     * Класс активной группы
     * @param groupId
     */
    getClass(groupId) {
      if (this.selectedGroup === groupId) return 'group-active'
      else return ''
    }
  }
}
</script>

<style>
.card {
  background: #fff;
  width: 100%;
  margin: 16px 16px 0;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.1);
  box-shadow: 0 3px 9px rgba(128, 128, 128, 0.125);
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #404344;
  letter-spacing: .5px;
  padding-right: 32px;
}

.card-subtitle {
  font-size: 14px;
  font-weight: 300;
  color: #595959;
  margin-top: 6px;
  font-family: 'Exo 2';
  line-height: 1.4;
}

.card-list {
  font-size: 15px;
  font-weight: 500;
  color: #404344;
  margin-top: 6px;
  margin-left: 16px;
  font-family: 'Exo 2';
  line-height: 1.4;
}

.card-bonuses {
  font-size: 18px;
  font-weight: 100;
  color: tomato;
  color: #20bf6b;
  margin-top: 6px;
}

.groups {
  padding: 16px;
}

.group {
  background: #0984e377;
  color: white;
  display: inline-block;
  margin: 0 12px 8px 0;
  padding: 6px 16px 5px;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.group-active {
  background: #0984e3;
}

.page-title {
  position: relative;
}

</style>